import type { User } from "@lumen/shared";
import { useParams } from "react-router-dom";
import { SiteOrganizationsWorkspace } from "./SiteOrganizationsWorkspace";

export function SiteOrganizationEditorPage({
  permissions,
  user,
}: {
  permissions: string[];
  user: User;
}) {
  const { organizationId } = useParams<{ organizationId: string }>();
  return (
    <SiteOrganizationsWorkspace
      permissions={permissions}
      user={user}
      mode="edit"
      organizationId={organizationId}
    />
  );
}
